function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAenixinline = function SvgAenixinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1940,
    height: 851,
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#00a5ff",
    d: "M635.5 156.5c-44.026 41.028-88.026 82.028-132 123 .065-.438-.101-.772-.5-1a26.523 26.523 0 0 1-3.5 6 30.137 30.137 0 0 0-6 3.5 24370.886 24370.886 0 0 1-237 219.5 64762.414 64762.414 0 0 1 220-350.5c52.999-.5 105.999-.667 159-.5",
    style: {
      opacity: 0.993
    },
    transform: "matrix(.07 0 0 .06992 -10.915 -9.555)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00abff",
    d: "M635.5 156.5h85c5.151.827 10.484 1.327 16 1.5a5271.626 5271.626 0 0 1-90 83c-6.181.172-12.181.672-18 1.5-11.671-.167-23.338 0-35 .5a1453.291 1453.291 0 0 1 9 40.5 60.364 60.364 0 0 0-8 5.5 2376.112 2376.112 0 0 1-74 68.5 3296.672 3296.672 0 0 0-17-78c43.974-40.972 87.974-81.972 132-123",
    style: {
      opacity: 0.995
    },
    transform: "matrix(.07 0 0 .06992 -10.915 -9.555)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00b2ff",
    d: "M720.5 156.5h146c-3.477.823-7.144 1.323-11 1.5a5271.626 5271.626 0 0 1-90 83c5.516.173 10.849.673 16 1.5h-153a159.141 159.141 0 0 1 18-1.5c30.3-27.299 60.3-54.965 90-83-5.516-.173-10.849-.673-16-1.5",
    style: {
      opacity: 0.992
    },
    transform: "matrix(.07 0 0 .06992 -10.915 -9.555)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00b8ff",
    d: "M866.5 156.5a2270.416 2270.416 0 0 0 41 43 1184.828 1184.828 0 0 0-40 42c-28.659 1-57.326 1.333-86 1-5.151-.827-10.484-1.327-16-1.5 30.3-27.299 60.3-54.965 90-83 3.856-.177 7.523-.677 11-1.5",
    style: {
      opacity: 0.99
    },
    transform: "matrix(.07 0 0 .06992 -10.915 -9.555)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0cf",
    d: "M1262.5 216.5h104v86h-104z",
    style: {
      opacity: 0.982
    },
    transform: "matrix(.07 0 0 .06992 -10.915 -9.555)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00b2ff",
    d: "m602.5 283.5 15 68c20.322 1 40.656 1.333 61 1v1c-11.671-.167-23.338 0-35 .5a5736.367 5736.367 0 0 1-103 94.5 5514.576 5514.576 0 0 0-20-91 2376.112 2376.112 0 0 0 74-68.5 60.364 60.364 0 0 1 8-5.5",
    style: {
      opacity: 0.987
    },
    transform: "matrix(.07 0 0 .06992 -10.915 -9.555)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00abff",
    d: "M499.5 284.5a433162.445 433162.445 0 0 0-99 168c5.151.827 10.484 1.327 16 1.5a53889.546 53889.546 0 0 1-205 190.5 421.042 421.042 0 0 1-41-1 9658.547 9658.547 0 0 1 86-136 24370.886 24370.886 0 0 0 237-219.5 30.137 30.137 0 0 1 6-3.5",
    style: {
      opacity: 0.992
    },
    transform: "matrix(.07 0 0 .06992 -10.915 -9.555)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00cbff",
    d: "M912.5 388.5a159736.41 159736.41 0 0 1 39-36h55c-.17 12.671 0 25.338.5 38 17.34-21.26 39.5-34.76 66.5-40.5 29.02-5.819 57.36-3.485 85 7 21.49 10.495 36.33 26.995 44.5 49.5a175.347 175.347 0 0 1 8 36c1.45 67.317 1.95 134.65 1.5 202h-96c.46-62.354-.04-124.688-1.5-187-1.41-11.31-5.91-21.143-13.5-29.5-16.33-10.034-33.67-12.034-52-6-24.94 9-38.44 26.833-40.5 53.5-.5 56.332-.67 112.666-.5 169h-96z",
    style: {
      opacity: 0.989
    },
    transform: "matrix(.07 0 0 .06992 -10.915 -9.555)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00beff",
    d: "M678.5 353.5v-1h136a538.89 538.89 0 0 0 33 1.5l-91 85c-33.998.5-67.998.667-102 .5a11157.715 11157.715 0 0 1 91-85.5c-22.331-.5-44.664-.667-67-.5",
    style: {
      opacity: 0.987
    },
    transform: "matrix(.07 0 0 .06992 -10.915 -9.555)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00c3ff",
    d: "M814.5 352.5h52v88h-214c.342-.838 1.008-1.172 2-1 34.002.167 68.002 0 102-.5l91-85a538.89 538.89 0 0 1-33-1.5",
    style: {
      opacity: 0.95
    },
    transform: "matrix(.07 0 0 .06992 -10.915 -9.555)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00c6ff",
    d: "M951.5 352.5a159736.41 159736.41 0 0 0-39 36v-36z",
    style: {
      opacity: 0.942
    },
    transform: "matrix(.07 0 0 .06992 -10.915 -9.555)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0cf",
    d: "M1394.5 352.5c36.33-.167 72.67 0 109 .5 20.17 25.5 40.33 51 60.5 76.5 20.17-25.5 40.33-51 60.5-76.5 36.33-.667 72.67-.667 109 0-38.67 47-77.33 94-116 141 41.9 49.815 83.57 99.815 125 150-36.67.667-73.33.667-110 0a15033.928 15033.928 0 0 1-69-85.5 8345.554 8345.554 0 0 0-68 85.5c-36.34.833-72.67.667-109-.5a8804.327 8804.327 0 0 1 124-149.5 7668.74 7668.74 0 0 1-116-141.5",
    style: {
      opacity: 0.987
    },
    transform: "matrix(.07 0 0 .06992 -10.915 -9.555)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00b8ff",
    d: "M678.5 353.5c22.336-.167 44.669 0 67 .5a11157.715 11157.715 0 0 0-91 85.5c-.992-.172-1.658.162-2 1a128.507 128.507 0 0 0-16 .5 113.73 113.73 0 0 1 3 12.5 5544.96 5544.96 0 0 0-93 85c-33.668.167-67.335 0-101-.5a11157.715 11157.715 0 0 0 91-85.5c3.991.628 5.324-.705 4-4a5736.367 5736.367 0 0 0 103-94.5c11.662-.5 23.329-.667 35-.5",
    style: {
      opacity: 1
    },
    transform: "matrix(.07 0 0 .06992 -10.915 -9.555)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0cf",
    d: "M1265.5 354.5h97v291h-97z",
    style: {
      opacity: 0.986
    },
    transform: "matrix(.07 0 0 .06992 -10.915 -9.555)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00b1ff",
    d: "M400.5 452.5h136a11157.715 11157.715 0 0 1-91 85.5c33.665.5 67.332.667 101 .5v1c-66.001-.167-132.001 0-198 .5a8123.657 8123.657 0 0 1-62 104c-24.998.5-49.998.667-75 .5a53889.546 53889.546 0 0 0 205-190.5c-5.516-.173-10.849-.673-16-1.5",
    style: {
      opacity: 0.976
    },
    transform: "matrix(.07 0 0 .06992 -10.915 -9.555)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00beff",
    d: "M639.5 453.5a7932.425 7932.425 0 0 1 17 77 7667.61 7667.61 0 0 0-77 72.5 19.177 19.177 0 0 1-5 2.5 2344.774 2344.774 0 0 1-14-66h-14v-1a5544.96 5544.96 0 0 1 93-85",
    style: {
      opacity: 0.993
    },
    transform: "matrix(.07 0 0 .06992 -10.915 -9.555)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00c4ff",
    d: "M656.5 530.5a509.055 509.055 0 0 0 6 26.5c10.995.5 21.995.667 33 .5a538.89 538.89 0 0 0 33 1.5 5390.309 5390.309 0 0 1-91 84c5.516.173 10.849.673 16 1.5h-71a1631.745 1631.745 0 0 0-8-39 19.177 19.177 0 0 0 5-2.5 7667.61 7667.61 0 0 1 77-72.5",
    style: {
      opacity: 0.988
    },
    transform: "matrix(.07 0 0 .06992 -10.915 -9.555)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00cbff",
    d: "M695.5 557.5h172v87h-214c-5.151-.827-10.484-1.327-16-1.5a5390.309 5390.309 0 0 0 91-84 538.89 538.89 0 0 1-33-1.5",
    style: {
      opacity: 0.977
    },
    transform: "matrix(.07 0 0 .06992 -10.915 -9.555)"
  }));
};
export default SvgAenixinline;